attachEvent('.sticky-box__arrow', 'click', (ev) => {
  const parentElem = ev.target.closest('.sticky-box');
  parentElem.classList.toggle('is-open');
});

document.addEventListener('click', (ev) => {
  const stickyBox = document.querySelector('.sticky-box');

  if (stickyBox && !stickyBox.contains(ev.target)) {
    stickyBox.classList.remove('is-open');
  }
});
